<template>
  <ApprovalConfirmation v-if="ApprovalListchange.length != 0 &&
    ApprovalListchange[0]?.['IsApproved'] != 1
  " :approvaldata="ApprovalListchange[0]" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
    @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" />
  <ApprovalStatus :ApprovalgetList="ApprovalList" :approvaldetails="approvaldetails" />
  <b-container class="overall-bg">
    <b-row>
      <b-col>
        <BacktoPage :goback="$router.back"></BacktoPage>
        <p class="common-heading1 my-3">
          {{ requestid }}
        </p>
        <!-- <b-row>
          <b-col>

          </b-col>
          <b-col>
            <div class="d-flex flex-row-reverse">
              <Button class="Actionsbtn p-button-sm" label="Actions" severity="info" @click="toggle"
                                    aria-haspopup="true" icon="pi pi-angle-down" aria-controls="overlay_menu"
                                    iconPos="right" size="small" />
                                <Menu ref="menu" id="overlay_menu" :model="action" :popup="true" />
            </div>
          </b-col>
        </b-row> -->
      </b-col>
    </b-row>
  </b-container>

  <section v-if="items.length !== 0" class="details_collapse">
    <b-container fluid>
      <b-row>
        <b-col>
          <p v-b-toggle.collapse-details variant="primary" class="float-end mb-3 pe-3">
            <span class="when-open">Collapse Flow Chart</span><span class="when-closed">Expand Flow Chart</span>
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-collapse visible id="collapse-details" class="mt-2">
      <RequestFlowChart :leftboxtext="data" :loading="loading" />
    </b-collapse>
  </section>

  <b-container class="form-white-bg">
    <div class="common-heading1 mt-3 mb-4">Items part of the request</div>
    <TabView class="tabview-custom transaction-tabs" ref="tabview4">
      <TabPanel>
        <template #header>
          <i class="pi pi-box pe-1"></i>
          <span>Items
            <Badge :value="items.length" severity="warning"></Badge>
          </span>
        </template>
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Item" econtent="Item"
              eimg="/src/assets/Img/icons/Item.svg" @createNew="" />
            <Tableview v-if="items.length !== 0" :value="items" :paginator="true" class="p-datatable-gridlines mt-5"
              :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="loading1"
              responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters">
              <template v-slot:Add> </template>
              <template v-slot:action="{ data }">
                <span>
                  <EditIcon @click="IsConfirmEdit(data)" class="me-3" />
                  <DeleteIcon @click="IsConfirmDel(data)" />
                </span>
              </template>
            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="items.length === 0 && !loading" eheader="Item" econtent="Item"
              eimg="/src/assets/Img/icons/Item.svg" @createNew="" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item["ItemCode"] }} /</p>
                    <p class="light-name">{{ item["HSNCode"] }}</p>
                    <p class="light-name" v-if="item['IssueCode']">
                      / {{ item["IssueCode"] }}
                    </p>
                  </div>
                  <p class="name">{{ item.Itemname1 }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Requested Quantity :</p>
                    <p class="small-name">
                      {{ item["ItemQuantity"] ? item["ItemQuantity"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Received Quantity :</p>
                    <p class="small-name">
                      {{ item["IssueQty"] ? item["IssueQty"] : "0" }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Returns :</p>
                    <p class="small-name">
                      {{ item["Returns"] ? item["Returns"] : "0" }}
                    </p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>

        <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
          :content="$t('confirmation.editcontent')" />
        <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
        <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
        <!-- </div> -->
      </TabPanel>
      <TabPanel>
        <template #header>
          <i class="pi pi-align-left pe-1"></i>
          <span>Logs
            <Badge :value="0" severity="warning"></Badge>
          </span>
        </template>
        <Log v-for="item in headers" />
      </TabPanel>
    </TabView>
  </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import Log from  "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import commonService from  "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRoute } from "vue-router";
import WithoutStockAffectService from  "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useRouter } from "vue-router";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import RequestFlowChart from "../../../../../../components/Chart/RequestFlowChart.vue";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import ApprovalConfirmation from "../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../components/FormComponents/ApprovalStatus.vue";
import PoApprovalService from  "../../../../../../modules/Inventory/Service/PoApprovalService";
import moment from "moment";

export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    Log,
    Loader,
    RequestFlowChart,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    MasterEmpty,
    ApprovalConfirmation,
    ApprovalStatus,
  },
  setup() {
    const routes = useRoute();
    let stocktransid = routes.query.Id;
    let status = routes.query.status ?? 0;
    const dataEdit = ref({});
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const router = useRouter();
    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);
    const menu = ref();
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      getApprovaldata();
      IsShow();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const action = ref([
      {
        items: [
          {
            label: "Close the request",
          },
          // {
          //     label: "Cancel PO",
          // },
        ],
      },
    ]);
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    let DeptRoleMapId = Number(rolesData.DeptRoleMapId);
    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      tostoreid: "",
      EntityId: 0
    });

    let approvaldetails: any = ref({
      HeaderName: "Request",
      ContentName: "Request",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    const toggle = (event: MouseEvent) => {
      menu.value.toggle(event);
    };
    const headers = [
      {
        header: "Item #",
        field: "ItemCode",
      },
      {
        header: "HSN#",
        field: "HSNCode",
      },
      {
        header: "Name",
        field: "Itemname1",
        bodyclass: "boldclass width150",
      },
      {
        header: "Issue Id",
        field: "IssueCode",
        bodyclass: "bluecolor",
      },
      {
        header: "Req Qty",
        field: "ItemQuantity",
        bodyclass: "boldclass",
      },
      {
        header: "Iss Qty",
        field: "IssueQty",
        bodyclass: "boldclass",
      },
      //   {
      //     header: "Consumed Quantity",
      //     field: "ItemQuantity",
      //     bodyclass: "boldclass",
      //   },
      // {
      //   header: "Available Quantity",
      //   field: "StockInHand",
      //   bodyclass: "boldclass",
      // },
      {
        header: "Returns",
        field: "ReturnQty",
        bodyclass: "boldclass",
      },
      // {
      //   header: "Total Value",
      //   field: "unit rate",
      // },
      // { field: "action", header: "Action", slot: "action",
      // frozencolumn: true, sortable: false },
    ];
    // const route = useRoute();

    // const paramValue = computed(() => {
    //     return route.query.param as string;
    // });
    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    let loading1 = ref(false);
    let loading = ref(false);
    let items: any = ref([]);
    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }
    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }
    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
        },
      });
    }
    async function IsDelete(data) { }
    let requestid = ref("");
    let ObjVal1 = ref({
      arraylenght: 0,
    });
    let ObjVal2 = ref({
      arraylenght: 0,
    });
    async function IsShow() {
      try {
        debugger;
        loading.value = true;
        const result = await WithoutStockAffectService.GetByStockWOTransId(
          stocktransid
        );
        items.value = result["result"];
        debugger;
        console.log(items.value);
        data.value.fromstr = result["result"][0].FromStoreName;
        data.value.tostr = result["result"][0].ToStoreName;
        data.value.fromstoreid = result["result"][0].FromStoreCode;
        data.value.tostoreid = result["result"][0].ToStoreCode;
        data.value.fromstatus = result["result"][0].FromStoreType;
        data.value.tostatus = result["result"][0].ToStoreType;
        data.value.fromcount = 0;
        data.value.EntityId = result["result"][0].EntityId;
        data.value.tocount = items.value.length;

        // approvaldetails.value.ApprovalPrice = data.grossamount
        approvaldetails.value.ApprovalCode = result["result"][0].DocNo;
        approvaldetails.value.ApprovalDate = result["result"][0].DocDateHR;
        approvaldetails.value.CreatedAt = result["result"][0].CreatedAt;
        requestid.value = result["result"][0].DocNo;
        loading.value = false;
      } catch { }
    }

    async function getApprovaldata() {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          stocktransid,
          usersData.OrganizationId,
          usersData.BranchId,
          data.value.EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == DeptRoleMapId
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0
    });

    async function Approve(Values) {
      debugger;
      try {
        isForm.value.EntityOperationId =
          ApprovalListchange.value[0]["EntityOperationId"];
        isForm.value.Id = ApprovalListchange.value[0]["ID"];
        isForm.value.EntityTransactionId =
          ApprovalListchange.value[0]["EntityTransactionId"];

        isForm.value.IsApproved = Values.Approvalstatus;
        isForm.value.Remarks = Values.Remarks;
        isForm.value.EntityId = data.value.EntityId;

        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus() {
      debugger;
      try {
        const response = await commonService.UpdateApprovalStatus(
          ApprovalListchange.value[0]["EntityTransactionId"],
          isForm.value.IsApproved
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
        }
      } catch (error) {
        console.log(error);
      }
    }

    return {
      ObjVal1,
      data,
      action,
      toggle,
      menu,
      globalFilterFields,
      items,
      headers,
      filters,
      loading1,
      loading,
      IsShow,
      IsConfirmEdit,
      dataEdit,
      Editmodel,
      deletepop,
      IsConfirmDel,
      closetrigger,
      IsEdit,
      Deletemodel,
      IsDelete,
      requestid,
      getApprovaldata,
      ApprovalList,
      ApprovalListchange,
      approvaldetails,
      Approve,
      SuccessfullPopUp,
      windowWidth,
    };
  },
});
</script>

<style lang="scss" scoped>
.tab-icon {
  width: 30px;
}

.blackbg {
  background-color: #303030;
  height: 150px;
}

.Actionsbtn {
  background-color: #0a82ff !important;
  border: none !important;
  padding: 8px !important;
}

// .itempart {}

// .logcard {
//     height: 30px;
// }</style>
